import _ from 'lodash';
import { connect } from 'react-redux';
import {
	get,
	publicGet,
	update,
	add,
	invalidate,
	publicSubmitPricing,
} from '../../modules/retailPricing/pricingRequest';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let pricingRequest;
	let pricingRequestId;

	if (ownProps.pricingRequest) {
		pricingRequest = ownProps.pricingRequest;
	} else {
		pricingRequestId = ownProps.pricingRequestId
			? ownProps.pricingRequestId
			: _.get(ownProps, ['match', 'params', 'pricingRequestId']);
		pricingRequest = _.get(state.maps, ['pricingRequest', pricingRequestId]);
	}

	return {
		pricingRequest,
		userMap: state.maps.user,
		stationMap: state.maps.station,
		gasBuddyPriceMap: state.maps.gasBuddyPrice,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getPricingRequest: get,
			updatePricingRequest: update,
			addPricingRequest: add,
			invalidatePricingRequest: invalidate,
			showErrors,
			publicGetPricingRequest: publicGet,
			publicSubmitPricing: publicSubmitPricing,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
